// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo__2V-c4","animation":"header_animation__2ZOwh","header":"header_header__P6cf0"};